import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Spin } from 'antd';

import { getPersonType, normalizeDocument } from '@eduzz-registry-360/validators';

import { useGtmAuth } from '@/hooks/useGtmAuth';
import { trpc } from '@/lib/trpc';
import useAuthStore from '@/stores/auth';
import useRegistryStore from '@/stores/registry';

export default function MagicLinkPage() {
  useGtmAuth();

  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const startedRef = useRef(false);
  const { setAuthData, setAuthCompleted } = useAuthStore(({ setAuthData, setAuthCompleted }) => ({
    setAuthData,
    setAuthCompleted
  }));
  const setRegistryFields = useRegistryStore(({ setFields }) => setFields);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const redeemMutation = trpc.auth.redeemMagicLink.useMutation();

  useEffect(() => {
    if (!uuid || startedRef.current) {
      return;
    }

    startedRef.current = true;

    void (async () => {
      let result;

      try {
        result = await redeemMutation.mutateAsync({ token: uuid });
      } catch {
        setErrorMessage('Este link é inválido ou expirou.');
        return;
      }

      const name = result.user.name ? result.user.name : 'Cadastro';
      const picture = result.user.picture ? result.user.picture : '';
      const email = result.user.email ? result.user.email : '';
      const document = normalizeDocument(result.user.document ? result.user.document : '');
      const personTypeFromDocument = getPersonType(document);
      const personType = personTypeFromDocument ? personTypeFromDocument : 'F';
      const companyType = result.user.companyType ? result.user.companyType : '';
      const companyName = result.user.companyName ? result.user.companyName : '';

      setAuthData({
        token: result.token,
        user: {
          id: result.user.id,
          eduzzId: result.user.eduzzId,
          name,
          picture,
          email,
          document: result.user.document,
          companyType,
          belt: result.user.belt
        }
      });

      setRegistryFields({
        document,
        bankAccountDocument: document,
        bankAccountType: personType === 'F' ? 'personal' : 'company',
        personType,
        companyType,
        ...(personType === 'J' && companyName ? { fullName: companyName, bankAccountOwner: companyName } : {})
      });

      setAuthCompleted();

      const searchParams = new URLSearchParams(location.search);

      if (result.redirectTo) {
        searchParams.set('redirectTo', result.redirectTo);
      }

      navigate({ pathname: '/', search: `?${searchParams.toString()}` }, { replace: true });
    })();
  }, [uuid, redeemMutation, setAuthData, setAuthCompleted, setRegistryFields, navigate, location.search]);

  if (errorMessage) {
    return (
      <div className='flex h-full w-full items-center justify-center p-6'>
        <p>{errorMessage}</p>
      </div>
    );
  }

  return (
    <div className='flex h-full w-full items-center justify-center'>
      <Spin size='large' />
    </div>
  );
}
